export default __webpack_public_path__ + "static/media/vampire_banner.9bba1f65.png";